export default __webpack_public_path__ + "a10d27aeab2c26736d71d175158d0c50.png";